// Tiny correlation-id helper.  Each logical "position search" mints one
// id and threads it through every layer (client → BFF → FastAPI → solver)
// via the `X-Trace-Id` HTTP header, so a single grep matches the entire
// chain of `[TRACE <id>] ...` log lines a single search produces.
//
// 8 hex chars: short enough to eyeball, wide enough that two concurrent
// searches won't collide.  Same length the backend's `_trace.new_trace_id`
// emits when it has to mint one itself (curl-style callers without the
// header).

export const TRACE_HEADER = 'X-Trace-Id';

export function newTraceId(): string {
  // crypto.randomUUID is widely available (Node 19+, all modern browsers).
  // Falling back to Math.random keeps the helper safe under jsdom-style
  // test envs that stub crypto.
  try {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID().replace(/-/g, '').slice(0, 8);
    }
  } catch {
    /* fall through */
  }
  return Math.floor(Math.random() * 0xffffffff).toString(16).padStart(8, '0');
}

/** `[TRACE <id>] <label>  k=v  k=v ...` — same format the backend uses,
 *  so a unified search across browser console + uvicorn output reads
 *  as one timeline. */
export function traceLog(traceId: string, label: string, fields: Record<string, unknown> = {}): void {
  const parts: string[] = [`[TRACE ${traceId}]`, label];
  for (const [k, v] of Object.entries(fields)) {
    if (typeof v === 'number' && !Number.isInteger(v)) {
      parts.push(`${k}=${v.toFixed(1)}`);
    } else {
      parts.push(`${k}=${String(v)}`);
    }
  }
  console.log(parts.join('  '));
}
